// Reviews
const reviews = document.querySelector('.reviews');

if (reviews) {
  const reviewsSlider = new Swiper('.reviews', {
    draggable: true,
    grabCursor: true,
    pagination: {
      el: '.reviews__pagination',
      type: 'bullets',
      clickable: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.review-button-next',
      prevEl: '.review-button-prev',
    },
    slidesPerView: 1,
  });
}
